import React, { useEffect, useState } from 'react'
import '../styles/Events.css'
import LiquidBlock from '../Blocks/LiquidBlock'
import LiquidRoundButton from '../Blocks/LiquidRoundButton'
import LiquidSelector from '../Blocks/LiquidSelector' // Добавляем импорт
import API from '../APIs/AdminApi'
import pen from '../imgs/pencil.svg'
import saveIcon from '../imgs/disk.svg'
import cancelIcon from '../imgs/cross-small.svg'
import userPen from '../imgs/user-pen.svg'
import downloadIcon from '../imgs/download.svg'
import ToggleSwitch from '../Blocks/ToggleSwitch'
import LiquidBlockTop from '../Blocks/LiquidBlockTop'
import * as XLSX from 'xlsx'

const Events = ({adminData}) => {
  const [events, setEvents] = useState([])
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [isCreateNew, setIsCreateNew] = useState(false)
  const [isEditing, setIsEditing] = useState(false)

  const [isEditingMembers, setIsEditingMembers] = useState(false)

  const [reloadKey, setReloadKey] = useState(0);

  const forceReload = () => {
    setReloadKey(prevKey => prevKey + 1);
  };

  // Состояние для нового/редактируемого мероприятия
  const [eventForm, setEventForm] = useState({
    name: '',
    description: '',
    place: '',
    date: '',
    time: '16:00-19:00',
    memberCount: '',
    canGraduaited: false,
    grades: [],
    status: 'regOpen'
  })

  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Буквы классов (А-З без Ё)
  const gradeLetters = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ж', 'З']
  const gradeNumbers = [9, 10, 11]

  // Статусы для создания и редактирования
  const createStatuses = [
    { value: 'regOpen', label: 'Открыто' },
    { value: 'regClosed', label: 'Закрыто' }
  ]

  const editStatuses = [
    { value: 'regOpen', label: 'Регистрация открыта' },
    { value: 'regClosed', label: 'Регистрация закрыта' },
    { value: 'eventClosed', label: 'Мероприятие завершено' }
  ]

  useEffect(() => {
    if(events.length == 0){
      API.LoadEvents().then((data) => {
        console.log(data.res);
        setEvents(data.res.data)
      })
    }
  }, [])

  // Функции для работы со временем
  const getTimeParts = (timeString) => {
    if (!timeString) return { startTime: '16:00', endTime: '19:00' };
    const [startTime, endTime] = timeString.split('-');
    return { startTime: startTime || '16:00', endTime: endTime || '19:00' };
  };

  const setTimeRange = (startTime, endTime) => {
    setEventForm(prev => ({
      ...prev,
      time: `${startTime}-${endTime}`
    }));
  };

  // ИСПРАВЛЕННАЯ функция форматирования даты
  const formatDateToDisplay = (dateString) => {
    if (!dateString) return '';
    
    // Если дата уже в формате дд.мм.гггг, просто возвращаем
    if (dateString.includes('.')) {
      return dateString;
    }
    
    // Если дата в формате гггг-мм-дд (из input type="date")
    if (dateString.includes('-')) {
      const [year, month, day] = dateString.split('-');
      return `${day}.${month}.${year}`;
    }
    
    // Пытаемся создать Date объект
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Если невалидная дата
      
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    } catch (error) {
      return dateString; // Возвращаем как есть в случае ошибки
    }
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    if (dateString.includes('.')) {
      const [day, month, year] = dateString.split('.');
      return `${year}-${month}-${day}`;
    }
    return dateString;
  };

  // Генерация временных вариантов для LiquidSelector
  const generateTimeOptions = () => {
    const times = [];
    for (let hour = 8; hour <= 23; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const timeString = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
        times.push({ value: timeString, label: timeString });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  // Обработчики для формы
  const handleInputChange = (field, value) => {
    
    setEventForm(prev => ({
      ...prev,
      [field]: value
    }));
    
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  // Обработчики для времени с LiquidSelector
  const handleStartTimeChange = (selectedTime) => {
    const time = selectedTime?.value || '16:00';
    const { endTime } = getTimeParts(eventForm.time);
    
    let newEndTime = endTime;
    if (time >= endTime) {
      const [hours, minutes] = time.split(':');
      newEndTime = `${String(parseInt(hours) + 1).padStart(2, '0')}:${minutes}`;
    }
    
    setTimeRange(time, newEndTime);
  };

  const handleEndTimeChange = (selectedTime) => {
    const time = selectedTime?.value || '19:00';
    const { startTime } = getTimeParts(eventForm.time);
    if (time > startTime) {
      setTimeRange(startTime, time);
    }
  };

  // Обработчик выбора класса и буквы
  const handleGradeToggle = (gradeNum, gradeLetter) => {
    setEventForm(prev => {
      const existingGradeIndex = prev.grades.findIndex(
        g => g.grade === gradeNum.toString() && g.gradeLetter === gradeLetter
      );
      
      let newGrades;
      if (existingGradeIndex >= 0) {
        newGrades = prev.grades.filter((_, index) => index !== existingGradeIndex);
      } else {
        newGrades = [...prev.grades, { grade: gradeNum.toString(), gradeLetter }];
      }
      
      return {
        ...prev,
        grades: newGrades
      };
    });
  };

  // Проверка выбран ли класс и буква
  const isGradeSelected = (gradeNum, gradeLetter) => {
    return eventForm.grades.some(
      g => g.grade === gradeNum.toString() && g.gradeLetter === gradeLetter
    );
  };

  // Обработчик создания мероприятия
  const handleCreateEvent = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      API.CreateEvent(adminData, eventForm).then((data) => {
        if(data.status == 200){
          API.LoadEvents().then((data) => {
            if(data.status == 200){
              setEvents(data.res.data);
              setTimeout(() => {
                forceReload()
              }, 1000)
            }
          }).catch(e => {
            console.error(e)
          })
           resetForm();
           setIsCreateNew(false);
           console.log('Мероприятие успешно создано');
        }
      }).catch(e => {
        console.error(e)
      });
    } catch (error) {
      setErrors({ submit: 'Ошибка соединения' });
      console.error('Ошибка при создании мероприятия:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Обработчик редактирования мероприятия
  const handleEditEvent = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      API.EditEvent(adminData, {
        ...eventForm,
        _id: selectedEvent._id
      }).then((data) => {
        console.log(data.res);
        if(data.status == 200){
          API.LoadEvents().then((data) => {
            if(data.status == 200){
              setEvents(data.res.data);
              setTimeout(() => {
                forceReload()
              }, 1000)
            }
          }).catch((e) => {
            console.error(e)
          })
          resetForm();
          setIsEditing(false);
          setSelectedEvent(eventForm);
          console.log('Мероприятие успешно обновлено');
        }
        
      });
      
    } catch (error) {
      setErrors({ submit: 'Ошибка соединения' });
      console.error('Ошибка при обновлении мероприятия:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDateChange = (value) => {
    if (value) {
      const [year, month, day] = value.split('-');
      const formattedDate = `${day}.${month}.${year}`;
      handleInputChange('date', formattedDate);
    } else {
      handleInputChange('date', '');
    }
  };

  // Валидация формы
  const validateForm = () => {
    const newErrors = {};
    const { startTime, endTime } = getTimeParts(eventForm.time);

    if (!eventForm.name.trim()) newErrors.name = 'Название обязательно';
    if (!eventForm.place.trim()) newErrors.place = 'Место проведения обязательно';
    if (!eventForm.date) newErrors.date = 'Дата обязательна';
    if (!startTime || !endTime) newErrors.time = 'Время обязательно';
    if (startTime >= endTime) newErrors.time = 'Время окончания должно быть позже времени начала';
    if (!eventForm.memberCount || eventForm.memberCount < 1) newErrors.memberCount = 'Количество участников должно быть больше 0';
    if (eventForm.grades.length === 0) newErrors.grades = 'Выберите хотя бы один класс';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Сброс формы
  const resetForm = () => {
    setEventForm({
      name: '',
      description: '',
      place: '',
      date: '',
      time: '16:00-19:00',
      memberCount: '',
      canGraduaited: false,
      grades: [],
      status: 'regOpen'
    });
    setErrors({});
  };

  // Обработчик начала редактирования
  const handleStartEdit = (event) => {
    setSelectedEvent(event);
    setIsEditing(true);
    setIsCreateNew(false);
    setEventForm({
      name: event.name,
      description: event.description || '',
      place: event.place,
      date: event.date,
      time: event.time || '16:00-19:00',
      memberCount: event.memberCount,
      canGraduaited: event.canGraduaited || false,
      grades: event.grades || [],
      status: event.status
    });
  };

  // Обработчик отмены
  const handleCancel = () => {
    resetForm();
    setIsCreateNew(false);
    setIsEditing(false);
    setSelectedEvent(null);
  };

  // Обработчик начала создания
  const handleStartCreate = () => {
    resetForm();
    setIsCreateNew(true);
    setIsEditing(false);
    setSelectedEvent(null);
  };

  const handleDeleteMember = (memberData) => {
    API.DeleteMember(adminData, selectedEvent, memberData).then((data) => {
      if(data.status == 200){
        window.location.reload()
      }
    })
  }

  const downloadMembersExcel = () => {
    if (!selectedEvent?.members || selectedEvent.members.length === 0) {
      alert('Нет участников для экспорта');
      return;
    }

    // Сортируем участников по фамилии (firstName)
    const sortedMembers = [...selectedEvent.members].sort((a, b) => {
      const lastNameA = a.firstName || '';
      const lastNameB = b.firstName || '';
      return lastNameA.localeCompare(lastNameB);
    });

    // Подготавливаем данные для Excel
    const excelData = sortedMembers.map((member, index) => ({
      '№': index + 1,
      'Фамилия': member.firstName || '', // firstName - это фамилия
      'Имя': member.secondName || '',    // secondName - это имя
      'Отчество': member.thirdName || '',
      'Статус': member.isGrad ? 'Выпускник' : `Ученик ${member.gradeNum}${member.gradeLetter}`,
      'ID пользователя': member.usMongoID || '',
      'Telegram ID': member.usTgID || ''
    }));

    // Создаем рабочую книгу
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(excelData);
    
    // Настраиваем ширину колонок
    ws['!cols'] = [
      { wch: 5 },  // №
      { wch: 15 }, // Фамилия
      { wch: 15 }, // Имя
      { wch: 15 }, // Отчество
      { wch: 20 }, // Статус
      { wch: 25 }, // ID пользователя
      { wch: 15 }  // Telegram ID
    ];

    // Добавляем заголовок с информацией о мероприятии
    const titleRow = [
      [`Мероприятие: ${selectedEvent.name}`],
      [`Дата: ${selectedEvent.date}`],
      [`Место: ${selectedEvent.place}`],
      [`Всего участников: ${selectedEvent.members.length}`],
      [''], // Пустая строка для разделения
      Object.keys(excelData[0]) // Заголовки колонок
    ];

    const wsWithTitle = XLSX.utils.aoa_to_sheet([
      ...titleRow,
      ...excelData.map(row => Object.values(row))
    ]);

    XLSX.utils.book_append_sheet(wb, wsWithTitle, "Участники");
    
    // Формируем имя файла
    const eventName = selectedEvent.name.replace(/[^a-zA-Zа-яА-Я0-9]/g, '_');
    const date = new Date().toISOString().split('T')[0];
    XLSX.writeFile(wb, `участники_${eventName}_${date}.xlsx`);
  };

  // Функция для получения отсортированного списка участников для отображения
  const getSortedMembers = () => {
    if (!selectedEvent?.members) return [];
    
    return [...selectedEvent.members].sort((a, b) => {
      const lastNameA = a.firstName || '';
      const lastNameB = b.firstName || '';
      return lastNameA.localeCompare(lastNameB);
    });
  };

  // Получаем текущие значения времени для отображения
  const { startTime, endTime } = getTimeParts(eventForm.time);

  return (<>
  {isEditingMembers ? <LiquidBlockTop>
      <div className="membEditTop">
        <LiquidRoundButton 
          onClick={() => {
            setSelectedEvent(null)
            setIsEditingMembers(false)
          }} 
        >
          ←
        </LiquidRoundButton>
        <h2>Участники {selectedEvent?.name}</h2>
        
        {/* Кнопка скачивания Excel */}
        <LiquidRoundButton 
          onClick={downloadMembersExcel}
          title="Скачать список участников в Excel"
        >
          <img className="editEventIcon" src={downloadIcon} alt="Скачать Excel" />
        </LiquidRoundButton>
      </div>
      
      <div className="membersListAdm">
        {getSortedMembers().map(member => { return (
          <LiquidBlock key={member.usMongoID}>
            <div className="memberBlock">
              <div className="memberData">
                <h4>{member.firstName} {member.secondName} {member.thirdName}</h4>
                {member.isGrad ? <p>Выпускник</p> : <p>Класс: {member.gradeNum}{member.gradeLetter}</p> }
                <p>
                  {member.ticketStatus !== 'notCome' ? 
                    <span className="usedTicketStatus">Использованный</span> : 
                    <span className="notUsedTicketStatus">Неиспользованный</span>
                  }
                </p>
              </div>
              {adminData?.canDeleteMembers && (
                <LiquidRoundButton onClick={() => handleDeleteMember(member)}>
                  <img className="editEventIcon" src={cancelIcon} alt="Удалить" />
                </LiquidRoundButton>
              )}
            </div>
          </LiquidBlock>
        )})}
      </div>
    </LiquidBlockTop> : null}
    <section className='eventsSection' key={reloadKey}>
      <h2>Мероприятия</h2>
      <div className="eventsSetings">
        <LiquidBlock>
          <div className="topEventsPanel">
              <h3 className='selAdmTxt'>Выберете Мероприятие</h3>
              {(adminData?.canCreateEvent) ? 
                <LiquidRoundButton onClick={handleStartCreate}>+</LiquidRoundButton> : null}
          </div>
        </LiquidBlock>

        {/* Форма создания/редактирования */}
        {(isCreateNew || isEditing) && (
          <LiquidBlock className="event-form-block">
            <div className="event-form-header">
              <h2>{isCreateNew ? 'Создание мероприятия' : 'Редактирование мероприятия'}</h2>
              <div className="event-form-actions">
                <LiquidRoundButton 
                  onClick={isCreateNew ? handleCreateEvent : handleEditEvent} 
                  disabled={isSubmitting}
                >
                  <img className="editEventIcon" src={saveIcon} alt="Сохранить" />
                </LiquidRoundButton>
                <LiquidRoundButton onClick={handleCancel} disabled={isSubmitting}>
                  <img className="editEventIcon" src={cancelIcon} alt="Отмена" />
                </LiquidRoundButton>
              </div>
            </div>

            {errors.submit && <div className="error-message">{errors.submit}</div>}

            <div className="event-form">
              {/* Основная информация */}
              <div className="form-section">
                <h3>Основная информация</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Название мероприятия *</label>
                    <input
                      type="text"
                      value={eventForm.name}
                      onChange={(e) => handleInputChange('name', e.target.value)}
                      className={errors.name ? 'error' : ''}
                    />
                    {errors.name && <span className="field-error">{errors.name}</span>}
                  </div>
                  <div className="form-group">
                    <label>Место проведения *</label>
                    <input
                      type="text"
                      value={eventForm.place}
                      onChange={(e) => handleInputChange('place', e.target.value)}
                      className={errors.place ? 'error' : ''}
                    />
                    {errors.place && <span className="field-error">{errors.place}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Дата *</label>
                    <input
                      type="date"
                      value={formatDateForInput(eventForm.date)}
                      onChange={(e) => handleDateChange(e.target.value)}
                      className={errors.date ? 'error' : ''}
                    />
                    {eventForm.date && (
                      <div className="date-display">
                        {formatDateToDisplay(eventForm.date)}
                      </div>
                    )}
                    {errors.date && <span className="field-error">{errors.date}</span>}
                  </div>
                  
                  <div className="form-group">
                    <label>Время начала *</label>
                    <LiquidSelector
                      options={timeOptions}
                      value={timeOptions.find(opt => opt.value === startTime)}
                      onChange={handleStartTimeChange}
                      placeholder="Выберите время начала"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className="time-selector"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Время окончания *</label>
                    <LiquidSelector
                      options={timeOptions.filter(opt => opt.value > startTime)}
                      value={timeOptions.find(opt => opt.value === endTime)}
                      onChange={handleEndTimeChange}
                      placeholder="Выберите время окончания"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className="time-selector"
                    />
                  </div>
                </div>

                {/* Блок с отображением выбранного времени */}

                <div className="form-row">
                  <div className="form-group">
                    <label>Количество участников *</label>
                    <input
                      type="number"
                      value={eventForm.memberCount}
                      onChange={(e) => handleInputChange('memberCount', parseInt(e.target.value) || '')}
                      className={errors.memberCount ? 'error' : ''}
                      min="1"
                    />
                    {errors.memberCount && <span className="field-error">{errors.memberCount}</span>}
                  </div>
                </div>

                <div className="form-group">
                  <label>Описание</label>
                  <textarea
                    value={eventForm.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    rows="3"
                  />
                </div>
              </div>

              {/* Бар статусов */}
              <div className="form-section">
                <h3>Статус регистрации</h3>
                <div className="status-bar">
                  {(isCreateNew ? createStatuses : editStatuses).map(status => (
                    <button
                      key={status.value}
                      type="button"
                      className={`status-btn ${eventForm.status === status.value ? 'status-active' : ''}`}
                      onClick={() => handleInputChange('status', status.value)}
                    >
                      {status.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Выбор классов */}
              <div className="form-section">
                <h3>Доступно для классов</h3>
                {errors.grades && <span className="field-error">{errors.grades}</span>}
                <div className="grades-selector">
                  {gradeNumbers.map(gradeNum => (
                    <div key={gradeNum} className="grade-group">
                      <h4>{gradeNum} класс</h4>
                      <div className="grade-letters">
                        {gradeLetters.map(letter => (
                          <button
                            key={letter}
                            type="button"
                            className={`grade-letter-btn ${isGradeSelected(gradeNum, letter) ? 'grade-selected' : ''}`}
                            onClick={() => handleGradeToggle(gradeNum, letter)}
                          >
                            {letter}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="graduaters">
                  <ToggleSwitch
                    label="Доступно выпускникам"
                    checked={eventForm.canGraduaited}
                    onChange={(value) => handleInputChange('canGraduaited', value)}
                  />
                </div>
                <div className="selected-grades">
                  <h4>Выбранные классы:</h4>
                  <div className="selected-grades-list">
                    {eventForm.grades.length > 0 ? (
                      eventForm.grades.map((grade, index) => (
                        <span key={index} className="selected-grade-tag">
                          {grade.grade}{grade.gradeLetter}
                        </span>
                      ))
                    ) : (
                      <span className="no-grades">Нет выбранных классов</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </LiquidBlock>
        )}

        {/* Список мероприятий */}
        {(isCreateNew || isEditing) ? null : 
        <div className="eventsSelector">
          <h3>Активные</h3>
            {events?.map(event => {
              if(event?.status != 'eventClosed') return (
              <LiquidBlock key={event?._id}>
                <div className='eventCardAdmin'>
                  <div className="textEventData">
                      <h2>{event?.name}</h2>
                      <p>{event?.date} | {event?.time} | {event?.members?.length}/{event?.memberCount}</p>
                      {event?.status == "regClosed" ? <h3 className='eventClosed'>Закрыто</h3> : event?.status == "regOpen" ? <h3 className='eventOpen'>Открыто</h3> : <h3 className='eventEnded'>Окончено</h3>}
                  </div>
                  <div className="eventButtonsEd">
                    
                  {(adminData?.canEditEvent || adminData?.canChangeEventStatus) && (
                    <LiquidRoundButton onClick={() => handleStartEdit(event)}>
                      <img className="editEventIcon" src={pen} alt="Редактировать" />
                    </LiquidRoundButton>
                  )}
                  
                    
                      <LiquidRoundButton onClick={() => {
                        setIsEditingMembers(true)
                        setSelectedEvent(event)
                      }}>
                        <img className="editEventIcon" src={userPen} alt="Редактировать" />
                      </LiquidRoundButton>
                    
                  </div>
                </div>
              </LiquidBlock>
            )})}
          <h3>Архив</h3>
          {events?.map(event => {
              if(event?.status == 'eventClosed') return (
              <LiquidBlock key={event?._id}>
                <div className='eventCardAdmin'>
                  <div className="textEventData">
                      <h2>{event?.name}</h2>
                      <p>{event?.date} | {event?.time} | {event?.members?.length}/{event?.memberCount}</p>
                      {event?.status == "regClosed" ? <h3 className='eventClosed'>Закрыто</h3> : event?.status == "regOpen" ? <h3 className='eventOpen'>Открыто</h3> : <h3 className='eventEnded'>Окончено</h3>}
                  </div>
                  {adminData?.canEditEvent || adminData?.canChangeEventStatus && (
                    <LiquidRoundButton onClick={() => handleStartEdit(event)}>
                      <img className="editEventIcon" src={pen} alt="Редактировать" />
                    </LiquidRoundButton>
                  )}
                    <LiquidRoundButton onClick={() => {
                      setIsEditingMembers(true)
                      setSelectedEvent(event)
                      }}>
                      <img className="editEventIcon" src={userPen} alt="Редактировать" />
                    </LiquidRoundButton>
                </div>
              </LiquidBlock>
            )})}
        </div>}
      </div>
    </section>
    </>
  )
}

export default Events;